export const OSS_BASE_URL = 'https://tqcagent.oss-cn-shanghai.aliyuncs.com';